import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'
import { parseApiUrl, parseFilters, parseOrderBy } from '../../../storeMixin'
import { axiosThux } from '../../../axiosThux'

const document = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/document/{profile}/document',
    app: 'document',
    evaluationDocList: [],
    subtypeList: [],
    legallyEquivalentList: [],
    coursesList: [],
    baseCertificationsList: {},
    pageOptions: [5, 10, 25, 50]
  },
  getters: {
    evaluationDocList (state) {
      return state.evaluationDocList
    },
    subtypeList (state) {
      return state.subtypeList
    },
    legallyEquivalentList (state) {
      return state.legallyEquivalentList
    },
    coursesList (state) {
      return state.coursesList
    },
    baseCertificationsList (state) {
      return state.baseCertificationsList
    }
  },
  mutations: {
    setEvaluationDocList (state, evaluationDocList) {
      state.evaluationDocList = evaluationDocList
    },
    setSubtypeList (state, subtypeList) {
      state.subtypeList = subtypeList
    },
    setLegallyEquivalentList (state, legallyEquivalentList) {
      state.legallyEquivalentList = legallyEquivalentList
    },
    setCoursesList (state, coursesList) {
      state.coursesList = coursesList
    },
    setBaseCertificationsList (state, baseCertificationsList) {
      state.baseCertificationsList = baseCertificationsList
    }
  },
  actions: {
    async getEvaluationdoclist ({ commit }, filters = {}) {
      let url = '/api/v1/document/{profile}/document/evaluation-doc-list/?no_page=no_page'
      url = parseFilters({ filters }, url)
      url = parseApiUrl(this, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setEvaluationDocList', response.data)
        })
    },
    // Fetch every training (Document is_training) without pagination, without touching
    // the visible (paginated) list. Used by the "Select all" button in the report modal.
    async getAllTrainingDocuments () {
      let url = '/api/v1/document/{profile}/document/training-list/?no_page=no_page'
      url = parseApiUrl(this, url)
      const response = await axiosThux.get(url)
      return response.data
    },
    async getSubtypeList ({ commit }, filters = {}) {
      let url = '/api/v1/document/{profile}/document/subtype-options/'
      url = parseFilters({ filters }, url)
      url = parseApiUrl(this, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setSubtypeList', response.data)
        })
    },
    async getLegallyEquivalentList ({ commit }, filters = {}) {
      let url = '/api/v1/document/{profile}/document/'
      url = parseFilters({ filters }, url)
      url = parseApiUrl(this, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setLegallyEquivalentList', response.data)
        })
    },
    async getCompanyDocuments ({ commit, getters }, filters = {}, documentType = 'aziendale') {
      let url = `/api/v1/document/{profile}/document/by-type/${documentType}/?`
      url = `${url}${getters.perPage ? 'per_page=' + getters.perPage : ''}`
      url = `${url}${getters.page ? '&page=' + getters.page : ''}`
      url = `${url}${getters.orderBy ? '&order_by__=' + getters.orderBy : ''}`
      url = parseOrderBy(getters, url)
      url = parseFilters({ filters }, url)
      url = parseApiUrl(this, url)
      const response = await axiosThux.get(url)
      commit('setList', response.data)
    },
    async setCoursesFilters ({ commit }, filters = {}) {
      let url = '/api/v1/document/{profile}/course/?no_page=no_page'
      url = parseFilters({ filters }, url)
      url = parseApiUrl(this, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setCoursesList', response.data)
        })
    },
    async setBaseCertificationsFilters ({ commit }, filters = {}) {
      let url = '/api/v1/document/{profile}/document/?'
      url = parseFilters({ filters }, url)
      url = parseApiUrl(this, url)
      return axiosThux.get(url)
        .then(response => {
          commit('setBaseCertificationsList', response.data)
        })
    }
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      {
        profile: 'GENERIC',
        app: 'document',
        model: 'document',
        listEntries: ['evaluationDocList']
      }
    ),
    {
      GENERIC: {
        document: {
          document: {
            LIST: {
              GETTERS: {
                subtypeList: 'GENERIC/document/document/subtypeList',
                coursesList: 'GENERIC/document/document/coursesList',
                baseCertificationsList: 'GENERIC/document/document/baseCertificationsList'
              },
              MUTATIONS: {
                setSubtypeList: 'GENERIC/document/document/setSubtypeList',
                setLegallyEquivalentList: 'GENERIC/document/document/',
                setCoursesList: 'GENERIC/document/document/setCoursesList',
                setBaseCertificationsList: 'GENERIC/document/document/setBaseCertificationsList'
              },
              ACTIONS: {
                getSubtypeList: 'GENERIC/document/document/getSubtypeList',
                getLegallyEquivalentList: 'GENERIC/document/document/',
                setCoursesFilters: 'GENERIC/document/document/setCoursesFilters',
                setBaseCertificationsFilters: 'GENERIC/document/document/setBaseCertificationsFilters'
              }
            }
          }
        }
      }
    }
  )
)()

export { document, TYPES }
